export default __webpack_public_path__ + "static/media/seltzer.e71c0c3a.jpg";